import React, { Suspense, lazy, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import AppLayouts from './layouts/appLayouts';
import AuthLayouts from './layouts/authLayouts';
import { useContextHelper } from 'helpers/ContextHelper';
import { useProfileDetails } from 'hooks/profile/profile';
import BulkUpload from 'views/app/configuration/product/builkUpload';
import globalRouter from 'globalRouter.ts';

// Lazy imports
const Login = lazy(() => import('./views/auth/login'));
const Forgot = lazy(() => import('./views/auth/forgot'));
const SetPassword = lazy(() => import('./views/auth/set-password'));
const Reports = lazy(() => import('./views/app/reports'));
const AssignRFID = lazy(() => import('./views/app/configuration/rfid'));
const CreateProduct = lazy(() => import('./views/app/configuration/product/create/index.jsx'));
const EditProduct = lazy(() => import('./views/app/configuration/product/edit/index'));
const Product = lazy(() => import('./views/app/configuration/product'));
const Category = lazy(() => import('./views/app/configuration/category'));
const Location = lazy(() => import('./views/app/configuration/location'));
const Inventory = lazy(() => import('./views/app/inventory'));
const ScannedProduct = lazy(() => import('./views/app/inventory/scanned-Product'));
const Admin = lazy(() => import('./views/app/user/admin'));
const Role = lazy(() => import('./views/app/user/role'));

const App = () => {
    const { setProfile } = useContextHelper();
    const { data: profileData, refetch } = useProfileDetails();
    const navigate = useNavigate();

    useEffect(() => {
        if (profileData) {
            setProfile(profileData?.data);
        }
    }, [profileData, setProfile]);

    useEffect(() => {
        globalRouter.navigate = navigate;
    }, [navigate]);

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Routes>

                {/* Public Routes - Auth Layout */}
                <Route element={<AuthLayouts />}>
                    <Route path="/" element={<Navigate to="/login" replace />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<Forgot />} />
                    <Route path="/setpassword" element={<SetPassword />} />
                </Route>

                {/* Protected Routes - Admin */}
                <Route element={<AppLayouts initialRefetch={refetch} roles={['ADMIN']} />}>
                    <Route path="/reports" element={<Reports />} />
                    <Route path="/configuration" element={<Navigate to="/configuration/rfid" replace />} />
                    <Route path="/configuration/rfid" element={<AssignRFID />} />
                    <Route path="/configuration/product" element={<Product />} />
                    <Route path="/configuration/product/add" element={<CreateProduct />} />
                    <Route path="/configuration/product/edit" element={<EditProduct />} />
                    <Route path="/configuration/product/bulk-upload" element={<BulkUpload />} />
                    <Route path="/configuration/category" element={<Category />} />
                    <Route path="/configuration/location" element={<Location />} />
                    <Route path="/inventory" element={<Inventory />} />
                    <Route path="/inventory/:id" element={<ScannedProduct />} />
                    <Route path="/user/admin" element={<Admin />} />
                    <Route path="/user/roles" element={<Role />} />
                </Route>

                {/* Protected Routes - User */}
                <Route element={<AppLayouts initialRefetch={refetch} roles={['user']} />}>
                    <Route path="/change" element={<div>Change Page (placeholder)</div>} />
                </Route>

                {/* 404 Fallback */}
                <Route path="*" element={<Navigate to="/login" replace />} />

            </Routes>
        </Suspense>
    );
};

export default App;
